var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end",
                      attrs: { md: "12" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "primary" },
                          on: { click: _vm.showAddTaxModal },
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-50",
                            attrs: { icon: "PlusIcon" },
                          }),
                          _vm._v(" New Tax "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "my-1",
                      attrs: { cols: "12", md: "2", sm: "2" },
                    },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "mb-0" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "d-inline-block text-sm-left mr-50",
                            },
                            [_vm._v("Per page")]
                          ),
                          _c("b-form-select", {
                            attrs: {
                              id: "perPageSelect",
                              size: "sm",
                              options: _vm.pageOptions,
                            },
                            model: {
                              value: _vm.perPage,
                              callback: function ($$v) {
                                _vm.perPage = $$v
                              },
                              expression: "perPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end mb-2",
                      staticStyle: { position: "relative", "z-index": "1" },
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-danger", size: "sm" },
                          on: { click: _vm.clearFilters },
                        },
                        [_vm._v(" Clear Filters ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          responsive: "",
                          items: _vm.paginatedFilteredTaxs,
                          fields: _vm.tax_fields,
                          filter: _vm.filter,
                          "filter-included-fields": _vm.filterOn,
                        },
                        on: { filtered: _vm.onFiltered },
                        scopedSlots: _vm._u([
                          {
                            key: "head(name)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [_vm._v(_vm._s(scope.label))]),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Search Tax Name",
                                        size: "sm",
                                      },
                                      model: {
                                        value: _vm.filters.name,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "name", $$v)
                                        },
                                        expression: "filters.name",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(taxAmount)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [_vm._v(_vm._s(scope.label))]),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Search Tax Rate",
                                        size: "sm",
                                        type: "number",
                                      },
                                      model: {
                                        value: _vm.filters.taxAmount,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filters,
                                            "taxAmount",
                                            $$v
                                          )
                                        },
                                        expression: "filters.taxAmount",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(code)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [_vm._v(_vm._s(scope.label))]),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Search Code",
                                        size: "sm",
                                      },
                                      model: {
                                        value: _vm.filters.code,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "code", $$v)
                                        },
                                        expression: "filters.code",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(description)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [_vm._v(_vm._s(scope.label))]),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Search Description",
                                        size: "sm",
                                      },
                                      model: {
                                        value: _vm.filters.description,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filters,
                                            "description",
                                            $$v
                                          )
                                        },
                                        expression: "filters.description",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(actions)",
                            fn: function (data) {
                              return [
                                _c(
                                  "b-dropdown",
                                  {
                                    staticClass: "m-1",
                                    attrs: {
                                      variant: "link",
                                      "toggle-class": "p-0",
                                      "no-caret": "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "button-content",
                                          fn: function () {
                                            return [
                                              _c("feather-icon", {
                                                staticClass:
                                                  "align-middle text-body",
                                                attrs: {
                                                  icon: "MoreVerticalIcon",
                                                  size: "16",
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.showViewTaxModal(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "EyeIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-1" },
                                          [_vm._v("View")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.showEditTaxModal(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "EditIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-1" },
                                          [_vm._v("Edit")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.confirmDeleteTax(
                                              data.item.id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "TrashIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-1" },
                                          [_vm._v("Delete")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c(
                        "b-row",
                        [
                          _c("b-form-group", [
                            _vm._v(
                              " Showing " +
                                _vm._s(
                                  _vm.totalRows > 0
                                    ? (_vm.currentPage - 1) * _vm.perPage + 1
                                    : 0
                                ) +
                                " to " +
                                _vm._s(
                                  _vm.totalRows > 0
                                    ? Math.min(
                                        _vm.currentPage * _vm.perPage,
                                        _vm.totalRows
                                      )
                                    : 0
                                ) +
                                " of " +
                                _vm._s(_vm.totalRows) +
                                " entries "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.perPage,
                          align: "center",
                          size: "sm",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  ref: "modalAddTax",
                  attrs: {
                    id: "modal-add-tax",
                    title: "Add New Tax",
                    "hide-footer": "",
                    centered: "",
                  },
                  on: { hide: _vm.resetForm },
                },
                [
                  _c("validation-observer", {
                    ref: "addTaxForm",
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var invalid = ref.invalid
                          var validate = ref.validate
                          return [
                            _c(
                              "b-form",
                              {
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    validate().then(function (success) {
                                      return success && _vm.addNewTax()
                                    })
                                  },
                                },
                              },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Tax Name",
                                      "label-for": "taxName",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Tax Name",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: { id: "taxName" },
                                                  model: {
                                                    value: _vm.newTax.name,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newTax,
                                                        "name",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "newTax.name",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Tax Rate",
                                      "label-for": "taxRate",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Tax Rate",
                                        rules:
                                          "required|numeric|min_value:0|max_value:100",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "taxRate",
                                                    type: "number",
                                                    step: "0.01",
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      _vm.newTax.taxAmount =
                                                        parseFloat(
                                                          _vm.newTax.taxAmount
                                                        )
                                                    },
                                                  },
                                                  model: {
                                                    value: _vm.newTax.taxAmount,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newTax,
                                                        "taxAmount",
                                                        _vm._n($$v)
                                                      )
                                                    },
                                                    expression:
                                                      "newTax.taxAmount",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Code",
                                      "label-for": "code",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Code",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: { id: "code" },
                                                  model: {
                                                    value: _vm.newTax.code,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newTax,
                                                        "code",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "newTax.code",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Description",
                                      "label-for": "description",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Description",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: { id: "description" },
                                                  model: {
                                                    value:
                                                      _vm.newTax.description,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newTax,
                                                        "description",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newTax.description",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  { attrs: { "label-for": "isTDS" } },
                                  [
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        attrs: { id: "isTDS" },
                                        model: {
                                          value: _vm.newTax.isTDS,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.newTax, "isTDS", $$v)
                                          },
                                          expression: "newTax.isTDS",
                                        },
                                      },
                                      [_vm._v(" Is TDS? ")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      type: "submit",
                                      variant: "primary",
                                      disabled: invalid,
                                    },
                                  },
                                  [_vm._v(" Add Tax ")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  ref: "modalEditTax",
                  attrs: {
                    id: "modal-edit-tax",
                    title: "Edit Tax",
                    "hide-footer": "",
                    centered: "",
                  },
                },
                [
                  _c("validation-observer", {
                    ref: "editTaxForm",
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var invalid = ref.invalid
                          var validate = ref.validate
                          return [
                            _c(
                              "b-form",
                              {
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    validate().then(function (success) {
                                      return success && _vm.updateTax()
                                    })
                                  },
                                },
                              },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Tax Name",
                                      "label-for": "taxName",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Tax Name",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: { id: "taxName" },
                                                  model: {
                                                    value: _vm.editTax.name,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editTax,
                                                        "name",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "editTax.name",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Tax Rate",
                                      "label-for": "taxRate",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Tax Rate",
                                        rules:
                                          "required|numeric|min_value:0|max_value:100",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "taxRate",
                                                    type: "number",
                                                    step: "0.01",
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      _vm.newTax.taxAmount =
                                                        parseFloat(
                                                          _vm.editTax.taxAmount
                                                        )
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editTax.taxAmount,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editTax,
                                                        "taxAmount",
                                                        _vm._n($$v)
                                                      )
                                                    },
                                                    expression:
                                                      "editTax.taxAmount",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Code",
                                      "label-for": "code",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Code",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: { id: "code" },
                                                  model: {
                                                    value: _vm.editTax.code,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editTax,
                                                        "code",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "editTax.code",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Description",
                                      "label-for": "description",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Description",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: { id: "description" },
                                                  model: {
                                                    value:
                                                      _vm.editTax.description,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editTax,
                                                        "description",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editTax.description",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  { attrs: { "label-for": "isTDS" } },
                                  [
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        attrs: { id: "isTDS" },
                                        model: {
                                          value: _vm.editTax.isTDS,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.editTax, "isTDS", $$v)
                                          },
                                          expression: "editTax.isTDS",
                                        },
                                      },
                                      [_vm._v(" Is TDS? ")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      type: "submit",
                                      variant: "primary",
                                      disabled: invalid,
                                    },
                                  },
                                  [_vm._v(" Save changes ")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  ref: "modalViewTax",
                  attrs: {
                    id: "modal-view-tax",
                    title: "View Tax",
                    "hide-footer": "",
                    centered: "",
                  },
                },
                [
                  _c(
                    "b-form",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Tax Name",
                            "label-for": "viewTaxName",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: { id: "viewTaxName", readonly: "" },
                            model: {
                              value: _vm.viewTax.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.viewTax, "name", $$v)
                              },
                              expression: "viewTax.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Tax Rate",
                            "label-for": "viewTaxRate",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: { id: "viewTaxRate", readonly: "" },
                            model: {
                              value: _vm.viewTax.taxAmount,
                              callback: function ($$v) {
                                _vm.$set(_vm.viewTax, "taxAmount", $$v)
                              },
                              expression: "viewTax.taxAmount",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-form-group",
                        {
                          attrs: { label: "Code", "label-for": "viewTaxCode" },
                        },
                        [
                          _c("b-form-input", {
                            attrs: { id: "viewTaxCode", readonly: "" },
                            model: {
                              value: _vm.viewTax.code,
                              callback: function ($$v) {
                                _vm.$set(_vm.viewTax, "code", $$v)
                              },
                              expression: "viewTax.code",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Description",
                            "label-for": "viewTaxDescription",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: { id: "viewTaxDescription", readonly: "" },
                            model: {
                              value: _vm.viewTax.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.viewTax, "description", $$v)
                              },
                              expression: "viewTax.description",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-form-group",
                        { attrs: { "label-for": "viewIsTDS" } },
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              attrs: {
                                id: "isTDS",
                                disabled: "",
                                readonly: "",
                              },
                              model: {
                                value: _vm.viewTax.isTDS,
                                callback: function ($$v) {
                                  _vm.$set(_vm.viewTax, "isTDS", $$v)
                                },
                                expression: "viewTax.isTDS",
                              },
                            },
                            [_vm._v(" Is TDS? ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }